/** Preferences in practice are tab-local. Operational defaults are never restored over another tab. */
let practiceScope:string|undefined
export function setPreferenceScope(scope?:string) { practiceScope=scope }
export function getPreferenceScope() { return practiceScope??'operations' }
export function getPreference(key:string):string|null {
  try {
    if(!practiceScope)return localStorage.getItem(key)
    const scoped='luuta-practice-pref:'+practiceScope+':'+key
    const cached=sessionStorage.getItem(scoped)
    if(cached!==null)return cached
    const inherited=localStorage.getItem(key)
    if(inherited!==null)sessionStorage.setItem(scoped,inherited)
    return inherited
  }catch{return null}
}
export function setPreference(key:string,value:string) {
  try { if(practiceScope)sessionStorage.setItem('luuta-practice-pref:'+practiceScope+':'+key,value);else localStorage.setItem(key,value) }catch{/* In-memory state remains usable. */}
}
